import { render, staticRenderFns } from "./flags.vue?vue&type=template&id=18f47d86&"
import script from "./flags.vue?vue&type=script&lang=js&"
export * from "./flags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports